import React, { Component } from "react";
import DownloadableMoviesTable from "../../components/tableComponent/downloadableMoviesTable";

class DownloadableMovies extends Component {
  render() {
    return (
      <React.Fragment>
        <h1>Downloadable Movies.</h1>
        <hr />
        <br />
        <DownloadableMoviesTable />
      </React.Fragment>
    );
  }
}

export default DownloadableMovies;
